<div class="mx-auto page-borders w-100">
  <form [formGroup]="purlSettingsForm" (ngSubmit)="saveSettings()" novalidate autocomplete="off">
    <div class="m-5">
      <div class="flex flex-row">
        <div class="page-header">Personal URL</div>
        <div class="flex-1"></div>
        <div style="justify-content: flex-end; padding-bottom: 5px;">
          <mrs-btn-primary class="float-end" buttonLabel="Save" buttonId="saveButton" type="submit">
          </mrs-btn-primary>
        </div>
      </div>
      <mat-slide-toggle labelPosition="before" class="d-inline-block" formControlName="isPurlEnabled" (change)="onEnabledToggle($event)">
        <div class="section-header">Activate Personal URL</div>
      </mat-slide-toggle>
    </div>

    <div class="m-5" *ngIf="purlEnabled">
      <div class="page-sub-header">Expiration</div>
      <mat-card appearance="outlined">

        <mat-card-content style="margin-left: 5px">
          <div class="flex flex-row" style="display: inline-block;">
            Personal URL expires
            <mat-form-field style="width: 75px">
              <input type="number" matInput formControlName="expirationDays" min="1" max="90">
              <mat-error *ngIf="purlSettingsForm.get('expirationDays').hasError('required')">required</mat-error>
              <mat-error *ngIf="purlSettingsForm.get('expirationDays').hasError('min')">Min value is 1</mat-error>
              <mat-error *ngIf="purlSettingsForm.get('expirationDays').hasError('max')">Max value is 90</mat-error>
            </mat-form-field>
            days after case creation.
          </div>
          <app-rich-text-editor class="configuration-editor" #expirationMessageEditor [htmlContent]="this.purlSettings?.expirationMessageText"
            title="Message" [config]="richTextEditorConfig">
          </app-rich-text-editor>
        </mat-card-content>
      </mat-card>


      <div class="page-sub-header mt-4">Verification</div>
      <mat-card appearance="outlined">

        <mat-card-content>
          <div class="flex flex-row" style="display: inline-block;">
            Maximum verification attempts:
            <mat-form-field style="width: 60px">
              <input type="number" matInput formControlName="numberOfRetries" min="1" max="10">
              <mat-error *ngIf="purlSettingsForm.get('numberOfRetries').hasError('required')">required</mat-error>
              <mat-error *ngIf="purlSettingsForm.get('numberOfRetries').hasError('min')">Min value is 1</mat-error>
              <mat-error *ngIf="purlSettingsForm.get('numberOfRetries').hasError('max')">Max value is 10</mat-error>
            </mat-form-field>
          </div>

          <app-rich-text-editor class="configuration-editor" #verificationAttemptsMessageEditor [htmlContent]="this.purlSettings?.verificationText"
            title="Message" [config]="richTextEditorConfig">
          </app-rich-text-editor>

          <div class="section-header mt-4">Questions</div>

          <div formArrayName="verificationQuestions">
            <div *ngIf="verificationQuestions.controls.length <=0" class="warning-text mt-1">
              Please select at least one verification question
            </div>
            <div class="mt-3">
              <ng-container *ngFor="let control of verificationQuestions.controls; let i = index; last as isLast">
                <div [formGroupName]="i" id="verificationQuestion" [ngClass]="{'mb-5': !isLast}">
                  <div class="flex flex-row">
                    <div>
                      <mat-form-field style="width:450px" class="me-2">
                        <mat-label>Select a verification Question</mat-label>
                        <mat-select formControlName="id" (selectionChange)="selectQuestion(i)">
                          <mat-option *ngFor="let question of questions" [value]="question.id">
                            {{question.mapKey.entityHierarchy}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="verificationQuestions.controls[i].get('id').hasError('unique')">Please choose
                          a question that hasn't been used</mat-error>
                      </mat-form-field>
                    </div>
                    <div style="display: flex; align-items: center; margin-bottom: 10px;">
                      <mat-icon svgIcon="delete" aria-label="Delete" (click)="deleteQuestion(i)"
                        class="mat-icon-gray"></mat-icon>
                    </div>
                  </div>
                  <div>
                    <div class="question-property-label">Question Text</div>
                    <angular-editor [config]="editorConfig" placeholder="Verification Question Text" id="html-input" [style]="{'height':'80px'}" formControlName="verificationText"></angular-editor>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <button type="button" mat-button color="primary" class="me-1 material-default" (click)="addQuestion()"
            style="text-transform: uppercase; padding-left: 0;">
            <mat-icon style="margin-bottom: 4px;">add</mat-icon>Add Question
          </button>
        </mat-card-content>
      </mat-card>
      <div class="page-sub-header mt-4">Welcome Message</div>
      <mat-card appearance="outlined">
        <mat-card-content>
          <div class="section-header mt-4">Header</div>
          <mat-form-field class="w-100">
            <input matInput type="text" formControlName="welcomeHeaderText" maxlength="50" #welcomeHeaderInput>
            <mat-hint align="end">{{welcomeHeaderInput.value?.length || 0}}/50</mat-hint>
            <mat-error *ngIf="purlSettingsForm.get('welcomeHeaderText').hasError('required')">required</mat-error>
          </mat-form-field>
          <div class="section-header mt-4">Body</div>
          <mat-form-field class="w-100 textarea-formfield">
            <mat-label>Welcome Body Text</mat-label>
            <textarea matInput type="text" formControlName="welcomeBodyText" matAutosizeMinRows="4"
              matAutosizeMaxRows="10"></textarea>
            <mat-error *ngIf="purlSettingsForm.get('welcomeBodyText').hasError('required')">required</mat-error>
          </mat-form-field>
        </mat-card-content>
      </mat-card>

      <div class="page-sub-header mt-4">Multi-Factor Authentication</div>      
        <mat-card appearance="outlined">
          <mat-card-content>
            <mat-slide-toggle labelPosition="before" class="d-inline-block" formControlName="requireMFA" (change)="onMFAEnabledToggle($event)">
              <div class="section-header">Require MFA</div>
            </mat-slide-toggle>
            <div *ngIf="requireMFA">
              <mat-form-field class="w-100">
                <mat-label>Question Text</mat-label>
                <input matInput type="text" formControlName="mfaQuestionText">
                <mat-error *ngIf="purlSettingsForm.get('mfaQuestionText').hasError('required')">required</mat-error>
              </mat-form-field>
              <mat-form-field class="w-100">
                <mat-label>MFA Code Expiry Time in Minutes</mat-label>
                <input matInput type="number" formControlName="mfaExpirationTime">
                <mat-error *ngIf="purlSettingsForm.get('mfaExpirationTime').hasError('required')">required</mat-error>
              </mat-form-field>                  
                <map-keys-dropdown [showRequiredError]="purlSettingsForm.get('mfaTokenMapkey').hasError('required')"
                  [displayList]="mapKeys" placeholder="Token Mapkey" formControlName="mfaTokenMapkey"
                  [formControl]="purlSettingsForm.get('mfaTokenMapkey')"></map-keys-dropdown>

              <div class="w-100  mb-4">
                <mat-slide-toggle labelPosition="before" class="d-inline-block" formControlName="mfaEmailEnabled" (change)="onMFAEmailEnabled($event)">
                  <div class="section-header">Email Verification</div>
                </mat-slide-toggle>
                <div *ngIf="purlSettingsForm.get('mfaEmailEnabled')  && purlSettingsForm.get('mfaEmailEnabled').value === true">
                  <mat-form-field class="w-100">
                    <mat-label>Email Question Label</mat-label>
                    <input matInput type="text" formControlName="mfaEmailQuestionLabel">
                    <mat-error *ngIf="purlSettingsForm.get('mfaEmailQuestionLabel').hasError('required')">required</mat-error>
                  </mat-form-field>
                  <map-keys-dropdown [showRequiredError]="purlSettingsForm.get('mfaEmailMapkey').hasError('required')"
                    [displayList]="mapKeys" placeholder="Email Mapkey" formControlName="mfaEmailMapkey"
                    [formControl]="purlSettingsForm.get('mfaEmailMapkey')"></map-keys-dropdown>
                  <mat-form-field class="w-100">
                    <mat-label>Email Subject</mat-label>
                    <input matInput type="text" formControlName="mfaEmailSubject">
                    <mat-error *ngIf="purlSettingsForm.get('mfaEmailSubject').hasError('required')">required</mat-error>
                  </mat-form-field>              
                  <app-rich-text-editor class="configuration-editor" #mfaEmailContentEditor [htmlContent]="this.purlSettings?.mfaEmailContent"
                    title="Email Body" [config]="richTextEditorConfig">
                  </app-rich-text-editor>                
                </div>
              </div>    

              <div class="w-100 mb-4">
                <mat-slide-toggle labelPosition="before" class="d-inline-block section-header" formControlName="mfaSMSEnabled" (change)="onSMSEmailEnabled($event)">
                  <div class="section-header">SMS Verification</div>
                </mat-slide-toggle>
                <div *ngIf="purlSettingsForm.get('mfaSMSEnabled') && purlSettingsForm.get('mfaSMSEnabled').value === true">
                <mat-form-field class="w-100">
                  <mat-label>SMS Question Label</mat-label>
                  <input matInput type="text" formControlName="mfaSMSQuestionLabel">
                  <mat-error *ngIf="purlSettingsForm.get('mfaSMSQuestionLabel').hasError('required')">required</mat-error>
                </mat-form-field>
                <map-keys-dropdown [showRequiredError]="purlSettingsForm.get('mfaSMSMapkey').hasError('required')"
                  [displayList]="mapKeys" placeholder="SMS Mapkey" formControlName="mfaSMSMapkey"
                  [formControl]="purlSettingsForm.get('mfaSMSMapkey')"></map-keys-dropdown>
                <mat-form-field class="w-100">
                  <mat-label>SMS Content</mat-label>
                  <input matInput type="text" formControlName="mfaSMSContent">
                  <mat-error *ngIf="purlSettingsForm.get('mfaSMSContent').hasError('required')">required</mat-error>
                </mat-form-field>                
                </div>          
              </div>
              <div *ngIf="!mfaEmailEnabled && !mfaSMSEnabled">
                <message-box class="message-box" title="No verification method enabled" message="At least one verification method needs to be enabled." ></message-box>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <div *ngIf="requireMFA">
        <div class="page-sub-header mt-4" >MFA Verification Page</div>
        <mat-card appearance="outlined">
          <mat-card-content>
            <mat-form-field class="w-100">
              <mat-label>Title</mat-label>
              <input matInput type="text" formControlName="mfaSecurityCodeTitle">
              <mat-error *ngIf="purlSettingsForm.get('mfaSecurityCodeTitle').hasError('required')">required</mat-error>
            </mat-form-field>
            <div *ngIf="purlSettingsForm.get('mfaEmailEnabled')  && purlSettingsForm.get('mfaEmailEnabled').value === true">
              <app-rich-text-editor class="configuration-editor" #mfaSecurityCodeEmailBodyEditor [htmlContent]="this.purlSettings?.mfaSecurityCodeEmailBody"
                title="Email Verification Text" [config]="richTextEditorConfig">
              </app-rich-text-editor>
            </div>
            <div *ngIf="purlSettingsForm.get('mfaSMSEnabled')  && purlSettingsForm.get('mfaSMSEnabled').value === true" class="mt-4">
              <app-rich-text-editor class="configuration-editor" #mfaSecurityCodeSMSBodyEditor [htmlContent]="this.purlSettings?.mfaSecurityCodeSMSBody"
                title="SMS Verification Text" [config]="richTextEditorConfig">
              </app-rich-text-editor>
            </div>
          </mat-card-content>
        </mat-card>

        <div class="page-sub-header mt-4" >MFA Error Details</div>
        <mat-card appearance="outlined">
          <mat-card-content>        
            <mat-form-field class="w-100">
              <mat-label>Error Title</mat-label>
              <input matInput type="text" formControlName="mfaErrorMessageTitle">
              <mat-error *ngIf="purlSettingsForm.get('mfaErrorMessageTitle').hasError('required')">required</mat-error>
            </mat-form-field>
            <app-rich-text-editor class="configuration-editor" #mfaErrorMessageBodyEditor [htmlContent]="this.purlSettings?.mfaErrorMessageBody"
                title="Error Message" [config]="richTextEditorConfig">
            </app-rich-text-editor>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </form>
</div>